import { injectAdv, initAdv } from '@sky-uk/sky-adv';

const ADV_MPU_SELECTOR = '.player-gallery-page .ftbl__football-team__adv-mpu';
const ADV_NATIVE_SELECTOR = '.player-gallery-page .ftbl__football-team__adv-native';

export function initPlayerPageAdv() {
  const ads = document.querySelectorAll(`${ADV_MPU_SELECTOR}, ${ADV_NATIVE_SELECTOR}`);

  ads.forEach((advElement: HTMLElement) => {
    injectAdv(advElement);
    initAdv(advElement);
  });
}
